import { render, staticRenderFns } from "./SelBookBranch.vue?vue&type=template&id=dee3527a"
import script from "./SelBookBranch.vue?vue&type=script&lang=js"
export * from "./SelBookBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports